<template>
    <div class="main">
        <a-row class="container" :gutter="8">
            <a-col :span="16">
                <a-form :form="form">
                    <a-form-item label="执行情况" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <vue-html5-editor :content="content" auto-height @change="updateData" ref="myeditor" ></vue-html5-editor>
                    </a-form-item>
                    <a-form-item label="我的任务" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-button type="danger" size="default" @click="chooseTask" v-if="!choosedTaskId">
                            选择我的执行任务<a-icon type="right" />
                        </a-button>
                        <a-tag closable color="#1890ff" @close="deleteTaskInfo" style="height: 32px;line-height: 32px;" v-else>{{choosedTaskName}}</a-tag>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <footer-tool-bar>
            <a-button type="danger" @click="deleteArticle" v-show="articleId">删除</a-button>
            <a-button type="primary" @click="handleSubmit">上报</a-button>
            <a-button type="primary" ghost @click="goBackToList">
                <a-icon type="left" />返回列表
            </a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import FooterToolBar from '../../components/FooterToolBar'
    export default {
        name: "AddTaskProgress",
        components:{
            FooterToolBar
        },
        beforeCreate () {
            this.form = this.$form.createForm(this);
        },
        data () {
            return {
                userInfo: '',
                content: '请输入内容',
                choosedTaskId: '',
                choosedTaskName: '',
                articleId: '',
                channelList: [],
                isShowModal: true,
                form: this.$form.createForm(this),
            }
        },
        methods: {
            handleSubmit (e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                    } else {
                        return
                    }
                    if (this.content === '请输入内容' || !this.content) {
                        this.$message.error('请填写任务执行情况')
                        return
                    }
                    if (!this.choosedTaskId) {
                        this.$message.error('请选择具体任务')
                        return
                    }
                    var postData = {'task_id': this.choosedTaskId, 'mark': this.content, 'dept_id': this.userInfo.dept_id, 'user_id': this.userInfo.userid, 'executor': this.userInfo.truename}
                    this.$http.post('api/assign/processmark', postData)
                        .then((res) => {
                            if (res.data.state === 200) {
                                // 发布成功 全部置空
                                this.content = ''
                                this.choosedTaskId = ''
                                this.choosedTaskName = ''
                                this.$store.commit('storeIsSelectingProgressAction', false)
                                this.$store.commit('storeAddProgressInfo', {content: ''})
                                this.$store.commit('storeAddProgressChoosedTaskInfo', {id: '', name: ''})
                                this.$message.success('发布成功')
                                setTimeout(() => {
                                    this.$router.push('/Main/Task/TaskProgressList')
                                }, 2000)
                            }
                        })
                        .catch(() => {
                        })
                })
            },
            updateData (content) {
                this.content = content
            },
            deleteArticle () {
                const that = this
                this.$confirm({
                    title: '确定删除该报题?',
                    content: '',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    centered: true,
                    onOk() {
                        that.deleting()
                    },
                    onCancel() {
                    },
                });
            },
            deleting () {
                this.$http.post('api/report/delete', {ids: this.articleId})
                    .then((res) => {
                        if (res.data.state === 200) {
                            this.$message.success('已删除')
                            setTimeout(() => {
                                this.$router.go(-1)
                            }, 2000)
                        }
                    })
                    .catch(() => {
                    })
            },
            goBackToList () {
                this.$router.push('/Main/Task/TaskProgressList')
            },
            chooseTask () {
                this.$store.commit('storeIsSelectingProgressAction', true)
                this.$store.commit('storeAddProgressInfo', {content: this.content})
                this.$router.push('/Main/Task/TaskProgressList')
            },
            deleteTaskInfo () {
                this.choosedTaskName = ''
                this.choosedTaskId = ''
                this.$store.commit('storeAddProgressChoosedTaskInfo', {id: '', name: ''})
            }
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted () {
            this.content = this.$store.state.addProgressInfo.content
            this.choosedTaskName = this.$store.state.addProgressChoosedTaskInfo.name
            this.choosedTaskId = this.$store.state.addProgressChoosedTaskInfo.id
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 56px;
    }
    .mgt10{
        margin-top: 10px;
    }
</style>
